import React from 'react';
import { useDrag, useDrop } from 'react-dnd';

interface IItem<T> {
    index: number;
    data: T;
}

interface IKnightProps<T> {
    children: React.ReactNode;
    data: IItem<T>;
    onDragEnd(item: IItem<T>, targetItem: IItem<T>): void;
    onHover(item: IItem<T>, targetItem: IItem<T>): void;
    onMoveItem(item: IItem<T>, targetItem: IItem<T>): void;
    onClick?(item: IItem<T>): void;
}

export const SortBox = <T,>(props: IKnightProps<T>) => {
    const { children, data, onDragEnd, onMoveItem, onHover } = props;
    const dragRef = React.useRef<HTMLDivElement>(null);

    const [{}, drag] = useDrag(
        () => ({
            type: 'tab-item',
            item: data,
            collect: (monitor) => ({
                isDragging: monitor.isDragging(),
            }),
            end(item) {
                onDragEnd(item as IItem<T>, data);
            },
        }),
        [data],
    );

    const [{}, drop] = useDrop(
        () => ({
            accept: 'tab-item',
            collect: (monitor) => ({
                isOver: monitor.isOver(),
                canDrop: monitor.canDrop(),
            }),
            drop(item) {
                onMoveItem(item as IItem<T>, data);
            },
            hover(item) {
                onHover(item as IItem<T>, data);
            },
        }),
        [data],
    );

    drag(drop(dragRef));

    return <div ref={dragRef}>{children}</div>;
};
